import React from "react";
import PropTypes from "prop-types";

// eslint-disable-next-line react/prefer-stateless-function
class SummaryAnalysisAPlusDialog extends React.Component {
  static propTypes = {
    content: PropTypes.string,
    href: PropTypes.string.isRequired,
    isFreeTier: PropTypes.bool.isRequired,
    linkClasses: PropTypes.string,
    logoSrc: PropTypes.string,
    logoSrcXs: PropTypes.string
  };

  static defaultProps = {
    content: undefined,
    linkClasses: undefined,
    logoSrc: undefined,
    logoSrcXs: undefined
  };

  render() {
    return (
      <div>
        <div className="text-center a-plus-dialog__header">
          <div className="tw-hidden sm:tw-block">
            <img
              alt="LitCharts Logo"
              className="brand"
              src={this.props.logoSrc}
            />
          </div>
          <div className="sm:tw-hidden">
            <img
              alt="LitCharts Logo"
              className="brand"
              src={this.props.logoSrcXs}
            />
          </div>
        </div>
        <div className="text-center a-plus-dialog__body subtitle-1">
          <p
            className="a-plus-dialog__content"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: this.props.content }}
          />
          <a
            className={`a-plus-dialog__subscribe btn btn-a-plus btn-md btn--icon-left ${
              this.props.linkClasses || ""
            }`}
            href={this.props.href}
            data-amplitude="litBlurredAnalysisPrimary"
          >
            <i className="lc-icon lc-icon-sm lc-icon-lock-filled" />
            Get <span className="tw-hidden sm:tw-inline">LitCharts </span>A
            <sup>+</sup>
          </a>
        </div>
        {!this.props.isFreeTier && (
          <div className="text-center a-plus-dialog__footer subtitle-2">
            <div className="a-plus-dialog__sign-in">
              <span className="a-plus-dialog__sign-in--text">or </span>
              <a href="/sign-in">sign in</a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SummaryAnalysisAPlusDialog;
